<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-12-15 14:37:15
 * @LastEditors: sjq
 * @LastEditTime: 2024-01-09 10:51:57
 -->
<template>
  <div class="learning-report">
    <div class="no-learning-report" v-if="pageMain === 2 || pageMain === 3">
      <img src="../../images/learningReport/no_img.png" alt="" class="img" />
      <div>未找到你的2023学习记录</div>
      <div v-if="pageMain === 3">领取5天畅听体验营资格</div>
      <div class="time-skip" v-if="pageMain === 3">{{ stime }}s后将自动跳转</div>
    </div>
    <template v-else-if="pageMain === 1">
      <div class="my-swiper">
        <swiper :options="swiperOption" ref="mySwiper" class="swiper">
          <swiper-slide v-for="(item, index) in num" :key="index" class="swiper-item" :class="'swiper-item' + index">
            <div v-show="activeIndex === index" v-if="index === 0">
              <img src="https://img-cdn1.ylyk.com/image/1703040011315_m1703137743000_s2781.jpg" alt="" class="moon" />
              <div class="text">
                <div class="text-1">对你来说</div>
                <div class="text-b text-2">2023</div>
                <div class="text-3">是怎样的一年?</div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 1">
              <img src="https://img-cdn1.ylyk.com/image/1703040011315_m1703036283000_s4247.jpg" alt="" class="moon" />
              <div class="text">
                <div class="text-1">是期待已久的</div>
                <div class="text-b text-1">重启？</div>
                <div class="text-2">是猝不及防的</div>
                <div class="text-b text-2">变化？</div>
                <div class="text-3">还是应接不暇的</div>
                <div class="text-b text-3">新挑战？</div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 2">
              <img src="https://img-cdn1.ylyk.com/image/1703040011315_m1703040870000_s1955.jpg" alt="" class="moon" />
              <div class="text">
                <div class="text-1">还好，</div>
                <div class="text-2">
                  你选择了
                  <b>「学习」</b>
                </div>
                <div class="text-3">作为人生的稳定器和指路灯</div>
                <div class="text-4">用坚定的姿态</div>
                <div class="text-5">应对一切变化和挑战</div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 3">
              <img src="https://img-cdn1.ylyk.com/image/1703040011315_m1703040979000_s4805.jpg" alt="" class="moon" />
              <div class="text">
                <div class="text-1">在进入新的一年之前</div>
                <div class="text-2">我们一起稍事休息，整理行囊</div>
                <div class="text-3">再继续踏上旅途</div>
              </div>
              <div class="text start-text text-4">
                <div class="">你的</div>
                <div class="">《2023友邻少年学习报告》</div>
                <div class="">在此开启</div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 4">
              <div class="text">
                <div class="text-1">这一年</div>
                <div class="text-2">
                  我们上新
                  <span class="num">30</span>
                  个专辑
                </div>
                <div class="text-3">
                  <span class="num">1436</span>
                  节课
                </div>
              </div>
              <div class="text album-text text-4">
                <div
                  :class="'text-size-' + (4 + key)"
                  v-for="(item, key) in [
                    '句读·苏东坡传',
                    '写作高频词',
                    '语言学',
                    '法律英语',
                    '简·奥斯丁',
                    '博物馆里的小故事',
                    '政治学',
                    '英文老唱片 第2季',
                    '天文馆里的小故事',
                    '......'
                  ]"
                  :key="item"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 5">
              <div class="text">
                <div>
                  <div class="text-1">2015-2023</div>
                  <div class="text-2">友邻在这八年时间里</div>
                </div>
                <div>
                  <div class="text-3">
                    已上架
                    <span class="num">680</span>
                    多张专辑
                  </div>
                  <div class="text-4">
                    近
                    <span class="num">30000</span>
                    节课
                  </div>
                </div>
                <div>
                  <div class="text-5">这座独一无二的</div>
                  <div class="text-6">英文学习图书馆已具规模</div>
                </div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 6">
              <div class="text">
                <div>
                  <div class="text-1 num">{{ detail.nickName }}</div>
                </div>
                <div>
                  <div class="text-2">你第一次来到友邻</div>
                  <div class="text-3">
                    是在
                    <span class="num fbe674">{{ detail.registerDay }}</span>
                  </div>
                  <div class="text-4">
                    一转眼我们已相识
                    <span class="num fbe674">{{ detail.daysDiff }}</span>
                    天
                  </div>
                </div>
                <div>
                  <div class="text-5">相知无远近</div>
                  <div class="text-6">万里尚为邻</div>
                  <div class="text-7">谢谢当时打开友邻的你</div>
                  <div class="text-8">让所有的相遇都恰逢其时</div>
                </div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 7">
              <div class="text">
                <div>
                  <div class="text-1">2023年</div>
                  <div class="text-2">
                    你一共学了
                    <span class="num fbe674">
                      {{ detail.totalLearnMinutes }}
                    </span>
                    分钟
                  </div>
                </div>
                <div>
                  <div
                    :class="'text-' + (3 + index)"
                    v-for="(item, index) in detail.totalLearnMinutes >= 3000
                      ? ['每一次学习', '都是一场灵魂的壮游', '这趟千里之行', '祝贺你遥遥领先']
                      : detail.totalLearnMinutes >= 600
                      ? ['人的一生，不是得到，而是学到', '走走停停，也很好', '反正，自由的灵魂总在路上']
                      : ['流水不争先', '争的是滔滔不绝', '希望过去的遗憾', '都成为你未来惊喜的铺垫']"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 8">
              <div class="text">
                <div>
                  <div class="text-1">这一年</div>
                  <div class="text-2">
                    你解锁了
                    <span class="num d7994c">{{ detail.albumCnt }}</span>
                    张专辑
                  </div>
                </div>
                <div>
                  <div class="text-3">
                    <span class="num d7994c">{{ detail.courseCnt }}</span>
                    节课
                  </div>
                  <div class="text-4">你听得最久的专辑是</div>
                  <div class="text-4 courseName d7994c">《{{ detail.learnMaxAlbumName }}》</div>
                </div>
                <div>
                  <div
                    :class="'text-' + (5 + index)"
                    v-for="(item, index) in detail.albumCnt >= 20
                      ? ['探路者永远不会拿着别人的地图', '来寻找自己的路', '愿你永远好奇', '永远步履不停']
                      : detail.albumCnt >= 6
                      ? ['英语学习没有终点', '只有里程碑', '那些格外偏爱', '注定成为生命中的精彩']
                      : ['这世界很喧嚣', '做你自己就好', '而这座不打烊的图书馆', '有一盏灯', '永远为你而亮']"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 9">
              <div class="text">
                <div>
                  <div class="text-1 fbe674 num">{{ detail.learnMaxDay }}</div>
                  <div class="text-2">是这一年里</div>
                  <div class="text-3">你在友邻停留最久的一天</div>
                </div>
                <div>
                  <div
                    :class="'text-' + (4 + parseInt(index / 2))"
                    v-for="(item, index) in [
                      '虽说雪落无痕',
                      '花落无声',
                      '但你听过的课',
                      '一定都藏在心里',
                      '等待着在未来',
                      '助你一臂之力'
                    ]"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 10">
              <div class="text">
                <div>
                  <div class="text-1">这一年</div>
                  <div class="text-2">
                    你一共完成了
                    <span class="num fbe674">
                      {{ detail.preListenCnt }}
                    </span>
                    次听力练习
                  </div>

                  <div class="text-3">
                    <span class="num fbe674">
                      {{ detail.exerciseCnt }}
                    </span>
                    次口语练习
                  </div>
                  <div class="text-4">
                    留下
                    <span class="num fbe674">
                      {{ detail.noteCnt }}
                    </span>
                    条留言
                  </div>
                  <div class="text-5">
                    送出
                    <span class="num fbe674">
                      {{ detail.likeCnt }}
                    </span>
                    个赞
                  </div>
                </div>
                <div>
                  <div
                    :class="'text-' + (6 + index)"
                    v-for="(item, index) in [
                      '那些喜欢，值得珍藏。那些思考，值得表达',
                      '2023，谢谢你与世界交流',
                      '向远方的人送去问候'
                    ]"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 11">
              <div class="text">
                <div>
                  <div class="text-1">谢谢你</div>
                  <div class="text-2">让「学习」成为2023的主旋律</div>
                </div>
                <div>
                  <div
                    :class="'text-' + (3 + index)"
                    v-for="(item, index) in ['2024，让我们继续上路', '一起回溯时光，品味经典', 'Time Matters']"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="text text-6 title-img">
                <img src="https://img-cdn1.ylyk.com/image/1704331050857_m1704331702000_s58891.jpg" alt="" />
              </div>
            </div>
            <div v-show="activeIndex === index" v-else-if="index === 12">
              <div class="text">
                <div>
                  <div
                    :class="'text-' + (1 + index)"
                    v-for="(item, index) in [
                      '都说学海无涯，逆水行舟',
                      '但好在德不孤，必有邻',
                      '语言的广阔天地里，我们一同成就'
                    ]"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                </div>
                <div>
                  <div class="text-4">愿新年，胜旧年！</div>
                </div>
              </div>
            </div>
            <div v-show="activeIndex === index" v-else class="swiper-item-share">
              <div class="share-img-box">
                <img :src="showShareImgUrl" alt="" class="share-img" />
              </div>
              <div class="share-btn">
                <div @click="shareImg" class="btn-common">分享</div>
                <div @click="getGoods" class="share-goods" v-if="!detail.campLimit">免费领取畅听资格</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="page-icon" @click.prevent.stop="nextPage" v-show="showUpglideIcon" v-if="activeIndex !== 13">
        <van-icon class="icon" name="arrow-up" />
        <div class="text" v-if="activeIndex === 0">上滑翻页</div>
        <div v-if="activeIndex === 3" class="sq-commit text-1">
          <div @click.stop>
            <Checkbox v-model="checked" shape="square" class="sq-checkbox">
              <span>勾选同意</span>
              <span class="active" @click="authorizeShow = true">授权说明</span>
            </Checkbox>
          </div>
          <div>查询我的听课数据</div>
        </div>
      </div>
    </template>
    <div class="back" @click="backToApp" v-if="appUser.isNative">
      <van-icon name="close" />
    </div>
    <div class="audio">
      <img class="img img-play" v-if="audioPlay" src="../../images/audio_icon.png" alt="" @click="playAudio" />
      <img class="img" v-else src="../../images/audio_pause_icon.png" alt="" @click="playAudio" />
      <audio src="https://mv-cdn1.ylyk.com/media/1703751255925_m1703751205864_s4067505.mp3" ref="mAudio"></audio>
    </div>
    <Popup v-model="authorizeShow" position="bottom" round>
      <div class="service-popup">
        <Icon name="cross" class="close-icon" @click="authorizeShow = false" />
        <div class="title">授权说明</div>
        <div class="authrize-commit">
          为了生成本次活动中专属于您的个人年度报告并向您做个性化展示，友邻少年App将根据您的本次授权查询并统计分析您2023年度，您账号的
          相关数据，包括：昵称及账号头像、注册时间、播放记录播放时长、评论及点赞记录等信息。您的报告根据算法生成，请您理解其与实际情况可能有所偏差。您可以自行查阅报告并保留，也可通过截屏或点击分享等方式将生成结果分享或公开给他人。如您不想参与本活动并授权我们查询及分析您的相关数据信息，您退出本页面即可。
          <br />
          勾选“同意”开启下一步。
        </div>
        <div @click="consentAgreement" class="btn-common">同意并勾选</div>
      </div>
    </Popup>
    <div id="poster">
      <img src="https://img-cdn1.ylyk.com/image/1704435899589_m1704436045401_s126260.jpg" alt="" class="share-img" />
      <div class="user-detail">
        <div class="user-avtarUrl"><img :src="detail.avtarUrl" alt="" /></div>
        <div class="user-list">
          <div>{{ detail.nickName }}</div>
          <div>《2023友邻少年学习报告》</div>
        </div>
        <div class="user-list">
          <div>听课总时长</div>
          <div class="fbe674">{{ detail.totalLearnMinutes }}分钟</div>
        </div>
        <div class="user-list">
          <div>解锁专辑数</div>
          <div class="fbe674">{{ detail.albumCnt }}张</div>
        </div>
        <div class="user-list">
          <div>最爱专辑</div>
          <div class="fbe674">《{{ detail.learnMaxAlbumName }}》</div>
        </div>
      </div>
      <div class="share-detail" v-if="showShareImgUrl">
        <div class="share-content">
          <div class="title">长按识别二维码</div>
          <div class="commit">和我一起「不功利」地学英语</div>
        </div>
        <div class="qr">
          <img :src="qrImgpath" alt="" />
        </div>
      </div>
    </div>
    <Overlay :show="shareShow" @click="shareShow = false" z-index="1000">
      <div class="share-wrapper" @click.stop>
        <img :src="shareImgUrl" alt="" class="share-img" />
        <div class="share-commit" @click="shareShow = false">长按保存图片，可分享至好友或朋友圈</div>
      </div>
    </Overlay>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { getYearLearn } from '@/api/modules/payment/learningReport'
import { Icon, Checkbox, Popup, Toast, Overlay } from 'vant'
import { saTrack } from '@/utils/common/shence'
import { appUser } from '@/utils'
import { $backToAppCallBack } from '@/utils/common/native-api'
import { $getShareImg } from '@/utils/common/native-api'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
import Body from '@/mixins/body'
import { toLoginView } from '@/utils/init/env-init'

const action = 'learningReport'

export default {
  components: { swiper, swiperSlide, vanIcon: Icon, Checkbox, Popup, Overlay },
  mixins: [Body],
  data() {
    return {
      appUser,
      swiperOption: {
        initialSlide: 0,
        speed: 1001, //切换速度
        direction: 'vertical', // 竖向滚动
        autoHeight: true, // 自适应高度
        slidesPerView: 'auto', // 记得这里写 auto 不要默认写1哦
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: false,
        resistanceRatio: 0,
        allowSlideNext: true,
        on: {
          // 当slideChange事件触发时，执行以下代码
          slideChange: () => {
            // 获取当前活动的slide索引
            // var activeIndex = this.activeIndex
            // 获取下一个slide的索引
            // var nextIndex = activeIndex + 1
            // console.log(activeIndex, this.activeIndex)
            // if (this.activeIndex === 0) {
            //   console.log('object')
            //   this.swiperOption.allowSlideNext = false
            //   console.log(this.swiperOption.allowSlideNext)
            // }
            // 检查是否到达最后一个slide
            // if (nextIndex >= swiper.slides.length) {
            //   // 如果到达最后一个slide，禁止向右翻页
            //   swiper.allowSlideNext = false
            // } else {
            //   // 如果未到达最后一个slide，允许向右翻页
            //   swiper.allowSlideNext = true
            // }
          },

          slideChangeTransitionStart: () => {},
          slideChangeTransitionEnd: () => {
            console.log('end')
            this.changeActiveIndex()
            // this.end()
          },
          touchStart: () => {
            this.start()
            console.log('函数触发了 start')
          },
          touchEnd: () => {
            setTimeout(() => {
              this.end()
            }, 500)
            console.log('函数触发了 end')
          },
          sliderMove: () => {
            this.start()
            console.log('函数触发了2 slidemove')
          }
          // transitionEnd: () => {
          //   this.end()
          // }
        }
      },
      showUpglideIcon: true,
      activeIndex: 0,
      textIndex: 1,
      stime: null,
      time: null,
      checked: false,
      pageMain: 1, //1有学习记录 2无学习记录且限购体验营 3无学习记录且不限购体验营
      detail: {},
      num: 0,
      authorizeShow: false,
      audioPlay: false,
      shareUserId: null,
      qrImgpath: '',
      shareImgUrl: '',
      showShareImgUrl: '',
      shareShow: false
    }
  },
  computed: {},
  watch: {
    activeIndex() {
      // if (this.activeIndex === 3) {
      //   if (this.checked) {
      //     this.$refs.mySwiper.enable()
      //   } else {
      //     this.$refs.mySwiper.disable()
      //   }
      // }
    },
    checked() {
      this.$refs.mySwiper.swiper.allowSlideNext = this.checked
    }
  },
  created() {
    this.shareUserId = this.$route.query.shareUserId
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getYearLearn()
  },
  mounted() {},
  beforeDestroy() {
    this.$refs.mAudio.pause()
  },
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      setTimeout(() => {
        this.getYearLearn()
      })
    },
    changeActiveIndex() {
      this.activeIndex = this.$refs.mySwiper.swiper.activeIndex
      saTrack('web_funczone_exp', {
        web_type: '2023年终学习报告',
        funczone_name: `第${this.activeIndex + 1}页`
      })
      if (this.activeIndex === 3 && !this.checked) {
        this.$refs.mySwiper.swiper.allowSlideNext = false
      }
      if (this.activeIndex !== 3) {
        this.$refs.mySwiper.swiper.allowSlideNext = true
      }
    },
    nextPage() {
      console.log(this.activeIndex < 3, this.checked)
      if (this.activeIndex < 3 || this.checked) this.$refs.mySwiper.swiper.slideNext()
    },
    getYearLearn() {
      getYearLearn({ shareUserId: this.shareUserId }).then(res => {
        console.log(res)
        this.detail = res
        const currentDate = new Date()
        const targetDate = new Date(res.registerDate.replace(/-/g, '/'))
        const timeDiff = currentDate.getTime() - targetDate.getTime()
        this.detail.daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))
        this.detail.registerDay =
          targetDate.getFullYear() + '年' + (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日'

        if (this.detail.totalLearnMinutes) {
          this.pageMain = 1
          this.$nextTick(() => {
            this.num = 14
            this.makeQRcode()
            saTrack('web_funczone_exp', {
              web_type: '2023年终学习报告',
              funczone_name: `第${this.activeIndex + 1}页`
            })
          })
        } else {
          this.pageMain = this.detail.campLimit ? 2 : 3
          if (this.pageMain === 3) {
            this.stime = 3
            this.time = setInterval(() => {
              this.stime--
              if (this.stime === 0) {
                clearInterval(this.time)
                location.replace(this.detail.goodsUrl)
              }
            }, 1000)
            saTrack(
              'autoTrack',
              {
                web_type: '2023年终学习报告',
                web_name: '无学习记录（不限购体验营）'
              },
              'quick'
            )
          } else {
            saTrack(
              'autoTrack',
              {
                web_type: '2023年终学习报告',
                web_name: '无学习记录（限购体验营）'
              },
              'quick'
            )
          }
        }
      })
    },
    end() {
      this.showUpglideIcon = true
      if (!this.audioPlay) {
        this.audioPlay = true
        this.$refs.mAudio.play()
      }
    },
    start() {
      if (this.activeIndex === 3 && !this.checked) {
        Toast('勾选授权说明才能查看报告哦～')
        return
      }
      this.showUpglideIcon = false
    },
    backToApp() {
      this.$refs.mAudio.pause()
      $backToAppCallBack()
    },
    shareImg() {
      saTrack('WebClick', {
        web_type: '2023年终学习报告',
        button_name: '分享'
      })
      if (appUser.isNative) {
        $getShareImg({
          imgUrl: this.shareImgUrl
        })
      } else {
        this.shareShow = true
      }
    },
    playAudio() {
      this.audioPlay = !this.audioPlay
      if (this.audioPlay) {
        this.$refs.mAudio.play()
      } else {
        this.$refs.mAudio.pause()
      }
    },
    consentAgreement() {
      this.authorizeShow = false
      this.checked = true
    },
    getGoods() {
      location.replace(this.detail.goodsUrl)
    },
    createImage() {
      console.log('11111')
      try {
        const capture = document.getElementById('poster')
        html2canvas(capture, {
          background: null,
          useCORS: true,
          width: capture.offsetWidth,
          height: capture.offsetHeight - 2,
          scrollX: 0,
          scrollY: 0,
          x: 0,
          y: 0,
          scale: 2
        })
          .then(canvas => {
            // document.body.appendChild(canvas)
            const dataURL = canvas.toDataURL('image/png')
            console.log(dataURL, !this.showShareImgUrl)
            if (!this.showShareImgUrl) {
              this.showShareImgUrl = dataURL
              setTimeout(() => {
                this.createImage()
                console.log('object')
              }, 1000)
            } else {
              this.shareImgUrl = dataURL
            }
          })
          .finally(() => {
            console.log('生成结束')
            Toast.clear()
          })
      } catch (err) {
        Toast.clear()
        console.log('error')
      }
    },
    //生成二维码
    makeQRcode() {
      console.log(window.location)
      let url =
        window.location.origin + window.location.pathname + '#/learningReport' + '?shareUserId=' + this.detail.userId
      console.log(url, 'utllll')
      if (!url) return
      const opts = {
        errorCorrectionLevel: 'L',
        type: 'image/jpeg',
        quality: 0.3,
        margin: 1
      }
      QRCode.toDataURL(url, opts).then(url => {
        this.qrImgpath = url
        setTimeout(() => {
          this.createImage()
        }, 1000)
      })
    }
  }
}
</script>
<style lang="scss">
.m-radio,
.sq-checkbox {
  justify-content: center;
  .sq-checkbox__icon {
    font-size: 0.22rem;
  }
  .van-checkbox__label {
    font-size: 0.24rem;
    color: #fff;
    margin-left: 3px;
  }
}
@media (min-width: 600px) {
  .m-radio,
  .sq-checkbox {
    justify-content: center;
    .van-checkbox__icon {
      font-size: 12px;
    }
    .van-checkbox__label {
      font-size: 16px;
      color: #fff;
      margin-left: 3px;
    }
  }
}
</style>
<style lang="scss" scoped>
// @media (min-width: 800px) {
// }

.learning-report {
  // background: #d38e43;
}
.my-swiper {
  // height: 100vh;
  .swiper-item {
    // padding: 20px;
    height: 100vh !important;
    max-width: 500px;
    margin: 0 auto;
    font-size: 0.32rem;
    > div {
      // border: solid #000 1px;
      height: 100%;
      // height: calc(100vh - 40px);
    }
  }
  .swiper-item0 {
    position: relative;
    // background-size: auto 100%;
    // background-position: center;
    .moon {
      position: absolute;
      width: 0.64rem;
      top: 50%;
      right: 21%;
      // right: 50%;
      // margin-right: -30%;
      margin-top: -6rem;
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -4.8rem;
      left: 34%;
      font-size: 0.52rem;

      .text-b {
        font-weight: bold;
        margin: 0.5rem 0;
        font-size: 1rem;
      }
    }
  }
  .swiper-item1 {
    position: relative;
    .moon {
      position: absolute;
      width: 0.64rem;
      top: 50%;
      left: 25%;
      margin-top: -3.4rem;
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -3.6rem;
      left: 55%;

      .text-b {
        font-weight: bold;
        margin: 0.32rem 0;
        font-size: 0.36rem;
      }
    }
  }
  .swiper-item2 {
    position: relative;
    .moon {
      position: absolute;
      width: 0.44rem;
      top: 50%;
      left: 27%;
      margin-top: 1.5rem;
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -6.4rem;
      left: 29%;
      font-size: 0.36rem;
      .text-b {
        font-weight: bold;
        margin: 0.32rem 0;
        font-size: 0.36rem;
      }
      :first-child {
        margin-bottom: 0.4rem;
      }
      div {
        margin-bottom: 0.3rem;
      }
    }
  }
  .swiper-item3 {
    position: relative;
    .moon {
      position: absolute;
      width: 0.44rem;
      top: 50%;
      left: 46%;
      margin-top: -6.22rem;
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -5.1rem;
      left: 0;
      right: 0;
      font-size: 0.36rem;
      text-align: center;
      .text-b {
        font-weight: bold;
        margin: 0.32rem 0;
        font-size: 0.36rem;
      }
      :first-child {
        margin-bottom: 0.4rem;
      }
      div {
        margin-bottom: 0.3rem;
      }
    }
    .start-text {
      bottom: 2rem;
      top: auto;
      margin-top: 0;
    }
  }
  .swiper-item4 {
    position: relative;
    .moon {
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -6.14rem;
      left: 0;
      right: 0;
      font-size: 0.36rem;
      text-align: center;
      .num {
        font-size: 0.5rem;
      }
      div {
        margin-bottom: 0.4rem;
      }
    }
    .album-text {
      margin-top: -1.3rem;
      left: 9%;
      right: auto;
      font-size: 0.6rem;
      text-align: left;
      .text-size-4 {
        margin-bottom: 0.5rem;
      }
      .text-size-5 {
        text-align: right;
        margin-right: -0.28rem;
      }
      .text-size-6 {
        font-size: 0.5rem;
        padding-left: 0.8rem;
      }
      .text-size-7 {
        font-size: 0.48rem;
        text-align: right;
        padding-right: 0.28rem;
      }
      .text-size-9 {
        font-size: 0.3rem;
        text-align: right;
        padding-right: 0.24rem;
      }
      .text-size-10 {
        font-size: 0.58rem;
      }
      .text-size-11 {
        font-size: 0.36rem;
        padding-left: 0.3rem;
        margin-bottom: 0.2rem;
      }
      .text-size-12 {
        font-size: 0.34rem;
        padding-left: 0.44rem;
        margin-bottom: 0.12rem;
      }
      .text-size-13 {
        text-align: center;
        font-size: 0.7rem;
        font-weight: bold;
      }
    }
  }
  .swiper-item5 {
    position: relative;
    .moon {
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -6.54rem;
      left: 0;
      right: 0;
      font-size: 0.32rem;
      text-align: center;
      .num {
        font-size: 0.5rem;
      }
      > div {
        margin-bottom: 0.73rem;
        > div {
          margin-bottom: 0.24rem;
        }
      }
      > div:last-child {
        color: #000;
        margin-top: 1.3rem;
      }
    }
  }
  .swiper-item6 {
    position: relative;
    .moon {
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -6rem;
      left: 0;
      right: 0;
      font-size: 0.32rem;
      text-align: center;
      .num {
        font-size: 0.45rem;
      }
      > div {
        margin-bottom: 0.78rem;
        > div {
          margin-bottom: 0.24rem;
        }
      }
    }
  }
  .swiper-item7 {
    position: relative;
    .moon {
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: 1.35rem;
      left: 0;
      right: 0;
      font-size: 0.32rem;
      text-align: center;
      .num {
        font-size: 0.45rem;
      }
      > div {
        margin-bottom: 0.85rem;
        > div {
          margin-bottom: 0.24rem;
        }
      }
    }
  }
  .swiper-item8 {
    position: relative;
    .moon {
    }
    .text {
      position: absolute;
      top: 50%;
      margin-top: -6.3rem;
      left: 0;
      right: 0;
      font-size: 0.32rem;
      text-align: center;
      .num {
        font-size: 0.45rem;
      }
      .courseName {
        font-size: 0.36rem;
      }
      > div {
        margin-bottom: 0.3rem;
        > div {
          margin-bottom: 0.24rem;
        }
        &:last-child {
          margin-top: 0.5rem;
        }
      }
    }
  }
  .swiper-item9 {
    position: relative;
    .moon {
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -5.9rem;
      left: 0;
      right: 0;
      font-size: 0.32rem;
      text-align: center;
      .num {
        font-size: 0.45rem;
      }
      > div {
        margin-bottom: 0.68rem;
        > div {
          margin-bottom: 0.2rem;
        }
      }
    }
  }
  .swiper-item10 {
    position: relative;
    .moon {
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -6.65rem;
      left: 0;
      right: 0;
      font-size: 0.32rem;
      text-align: center;
      .num {
        font-size: 0.45rem;
      }
      > div {
        margin-bottom: 0.68rem;
        > div {
          margin-bottom: 0.3rem;
        }
      }
    }
  }
  .swiper-item11 {
    position: relative;
    .moon {
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -6.2rem;
      left: 0;
      right: 0;
      font-size: 0.32rem;
      text-align: center;
      .num {
        font-size: 0.45rem;
      }
      > div {
        margin-bottom: 0.9rem;
        > div {
          margin-bottom: 0.3rem;
        }
      }
    }
    .title-img {
      margin-top: -0.2rem;
      width: 4rem;
      left: 20%;
      right: auto;
    }
  }
  .swiper-item12 {
    position: relative;
    .moon {
    }
    .text {
      color: #fff;
      position: absolute;
      top: 50%;
      margin-top: -5.65rem;
      left: 0;
      right: 0;
      font-size: 0.32rem;
      text-align: center;
      .num {
        font-size: 0.45rem;
      }
      > div {
        margin-bottom: 0.9rem;
        > div {
          margin-bottom: 0.3rem;
        }
      }
    }
  }
  .swiper-item13 {
    background-size: 100%;
  }
  .swiper-item-share {
    padding: 0 0.48rem;
    display: flex;
    flex-direction: column;
    .share-img-box {
      padding: 5vh 0 2vh;
      overflow: hidden;
      text-align: center;
      pointer-events: none;
      .share-img {
        border-radius: 0.16rem;
      }
    }

    .share-btn {
      height: 1.88rem;
      text-align: center;
      padding-bottom: 0.22rem;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      flex: 1;

      .share-goods {
        color: #00b25a;
        font-size: 0.24rem;
        text-decoration-line: underline;
      }
    }
  }
}
@keyframes slide-in-bottom {
  0% {
    // transform: translateY(100px);
    opacity: 0;
  }
  // 5% {
  //   transform: translateY(50px);
  //   opacity: 0.5;
  // }
  100% {
    // transform: translateY(0);
    opacity: 1;
  }
}
@for $i from 1 through 20 {
  // 遍历数组
  // 获取数组中第i项的值 nth($arr, $i)
  // 获取指定键值 map-get(nth($arr, $i), $key)
  .text-#{ $i} {
    animation: slide-in-bottom 1s ease 0s 1 normal backwards;
    animation-delay: ($i - 1) * 1s;
  }
}

$arr: (
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s29200.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703040011315_m1703495785000_s93515.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s28847.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703040011315_m1703495952000_s101147.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704407016000_s44174.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703040011315_m1703496289000_s121966.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s23927.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703040011315_m1703496019000_s117573.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s40496.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703642075676_m1703639974000_s199239.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s35467.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703656206053_m1703648324000_s158013.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s36507.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703656206053_m1703648404000_s430824.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s35243.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703656206053_m1703648429000_s165015.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s35554.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703656206053_m1703648520000_s328055.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s40324.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1703656206053_m1703648546000_s205148.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s29187.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1704331050857_m1704164539000_s173436.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s34604.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1704331050857_m1704164798000_s212118.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s67915.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1704331050857_m1704164941000_s247266.jpg'
  ),
  (
    bgUrl: 'https://img-cdn1.ylyk.com/image/1704435899589_m1704406930000_s19356.jpg',
    oldBgUrl: 'https://img-cdn1.ylyk.com/image/1704331050857_m1704349434485_s68324.jpg'
  )
);

@for $i from 1 through length($arr) {
  $item: nth($arr, $i); // 获取数组中第i项的值
  $bgUrl: map-get($item, bgUrl);
  $oldBgUrl: map-get($item, oldBgUrl);
  .swiper-item#{ $i - 1 } {
    background: url($bgUrl) no-repeat;
    // background: url($oldBgUrl) no-repeat;
    background-size: 100% auto;
    background-position-y: center;
  }
}

.page-icon {
  position: fixed;
  bottom: 0.5rem;
  color: #fff;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 111;
  .icon {
    font-size: 0.56rem;
    animation: up-icon 1s linear 0s infinite normal backwards;
  }
  .sq-commit {
    font-size: 0.24rem;
    .active {
      color: #00b25a;
      font-weight: bold;
      text-decoration-line: underline;
    }
  }
}

@keyframes up-icon {
  0% {
    transform: translateY(0px);
    opacity: 0.2;
  }
  // 50% {
  //   transform: translateY(-5px);
  //   opacity: 0.4;
  // }
  50% {
    transform: translateY(-0.32rem);
    opacity: 1;
  }
  // 75% {
  //   transform: translateY(-15px);
  //   opacity: 0.5;
  // }
  100% {
    transform: translateY(-0.64rem);
    opacity: 0.1;
  }
}
// .text-effect {
//   /* 特效颜色 */
//   --effect-color: #fff;
//   /* 无特效时的普通文本颜色 */
//   --normal-color: transparent;
//   position: relative;
//   color: var(--normal-color);
//   &::before {
//     content: attr(data-text-effect-content);
//     position: absolute;
//     color: var(--effect-color);
//     width: 0;
//     height: 120%;
//     white-space: nowrap;
//     overflow: hidden;
//     animation: text-effect 3s linear forwards;
//   }
//   @keyframes text-effect {
//     0% {
//       width: 0;
//     }

//     100% {
//       width: 100%;
//     }
//   }
// }
.no-learning-report {
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  height: 100vh;
  padding-top: 100px;
  background: linear-gradient(0, #fff 10%, #ebf3fb 80%);
  .img {
    width: 4rem;
    max-width: 400px;
  }
  div {
    line-height: 1.5;
  }
  .time-skip {
    color: #00b25a;
    margin-top: 0.32rem;
  }
}
.back {
  position: fixed;
  top: 1rem;
  right: 0.32rem;
  color: #fff;
  font-size: 0.56rem;
  z-index: 9;
}
.audio {
  position: fixed;
  top: 1rem;
  left: 0.32rem;
  color: #fff;
  font-size: 0.56rem;
  z-index: 9;
  .img {
    width: 0.48rem;
  }
  .img-play {
    animation: turn 2s linear infinite;
  }
}

@keyframes turn {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (min-width: 500px) {
  .back {
    right: 50%;
    margin-right: -19vh;
    font-size: 32px;
    top: 80px;
    .img {
      width: 24px;
    }
  }
  .audio {
    left: 50%;
    margin-left: -19vh;
    font-size: 32px;
    top: 80px;
  }
  .page-icon {
    bottom: 50px;
    .icon {
      font-size: 24px;
    }
    .sq-commit {
      font-size: 16px;
    }
  }
  .my-swiper {
    .swiper-item {
      background-size: auto 100%;
      background-position: center;
      .text {
        font-size: 38px;
        .text-b {
          font-size: 27px;
          margin: 30px 0;
        }
      }
    }
    .swiper-item0 {
      .moon {
        width: 42px;
        margin-top: -400px;

        right: 50%;
        margin-right: -30%;
        top: 0;
        margin-top: 13vh;
      }
      .text {
        margin-top: -314px;

        .text-b {
          font-size: 62px;
          margin: 38px 0;
        }
      }
    }
    .swiper-item1 {
      .moon {
        width: 42px;
        margin-top: -224px;
      }
      .text {
        font-size: 25px;
        margin-top: -274px;

        .text-b {
        }
      }
    }
    .swiper-item2 {
      .moon {
        width: 26px;
        margin-top: 100px;
      }
      .text {
        font-size: 25px;
        margin-top: -423px;
        :first-child {
          margin-bottom: 28px;
        }
        div {
          margin-bottom: 30px;
        }
      }
    }
    .swiper-item3 {
      .moon {
        width: 30px;
        margin-top: -414px;
      }
      .text {
        font-size: 25px;
        margin-top: -336px;
        :first-child {
          margin-bottom: 28px;
        }
        div {
          margin-bottom: 30px;
        }
      }
      .start-text {
        bottom: 170px;
      }
    }
    .swiper-item4 {
      .text {
        font-size: 25px;
        margin-top: -360px;
        :first-child {
          margin-bottom: 28px;
        }
        div {
          margin-bottom: 30px;
        }
        .num {
          font-size: 25px;
        }
      }
      .album-text {
        margin-top: -73px;
        font-size: 30px;
        text-align: left;
        left: 50%;
        margin-left: -16vh;
        right: auto;

        .text-size-4 {
          margin-bottom: 25px;
        }
        .text-size-5 {
          text-align: right;
          margin-right: 14px;
        }
        .text-size-6 {
          font-size: 25px;
          padding-left: 40px;
        }
        .text-size-7 {
          font-size: 24px;
          text-align: right;
          padding-right: 14px;
        }
        .text-size-9 {
          font-size: 15px;
          text-align: right;
          padding-right: 12px;
        }
        .text-size-10 {
          font-size: 29px;
        }
        .text-size-11 {
          font-size: 18px;
          padding-left: 15px;
          margin-bottom: 10px;
        }
        .text-size-12 {
          font-size: 17px;
          padding-left: 22px;
          margin-bottom: 6px;
        }
        .text-size-13 {
          text-align: center;
          font-size: 35px;
          font-weight: bold;
        }
      }
    }
    .swiper-item5 {
      .text {
        margin-top: -384px;
        font-size: 20px;
        .num {
          font-size: 25px;
        }
        > div {
          margin-bottom: 50px;
          > div {
            margin-bottom: 14px;
          }
        }
        > div:last-child {
          margin-top: 85px;
        }
      }
    }
    .swiper-item6 {
      .text {
        margin-top: -350px;
        font-size: 20px;
        .num {
          font-size: 25px;
        }
        > div {
          margin-bottom: 50px;
          > div {
            margin-bottom: 18px;
          }
        }
      }
    }

    .swiper-item7 {
      .text {
        margin-top: 84px;
        font-size: 20px;
        .num {
          font-size: 25px;
        }
        > div {
          margin-bottom: 50px;
          > div {
            margin-bottom: 18px;
          }
        }
      }
    }
    .swiper-item8 {
      .text {
        margin-top: -368px;
        font-size: 20px;
        .num {
          font-size: 25px;
        }
        > div {
          margin-bottom: 19px;
          > div {
            margin-bottom: 18px;
          }
        }
      }
    }
    .swiper-item9 {
      .text {
        margin-top: -346px;
        font-size: 20px;
        .num {
          font-size: 25px;
        }
        > div {
          margin-bottom: 40px;
          > div {
            margin-bottom: 16px;
          }
        }
      }
    }
    .swiper-item10 {
      .text {
        margin-top: -390px;
        font-size: 20px;
        .num {
          font-size: 25px;
        }
        > div {
          margin-bottom: 55px;
          > div {
            margin-bottom: 16px;
          }
        }
      }
    }
    .swiper-item11 {
      .text {
        margin-top: -360px;
        font-size: 20px;
        .num {
          font-size: 25px;
        }
        > div {
          margin-bottom: 55px;
          > div {
            margin-bottom: 16px;
          }
        }
      }
      .title-img {
        margin-top: -0;
        width: 24vh;
      }
    }
    .swiper-item12 {
      .text {
        margin-top: -330px;
        font-size: 20px;
        .num {
          font-size: 25px;
        }
        > div {
          margin-bottom: 55px;
          > div {
            margin-bottom: 16px;
          }
        }
      }
    }
    .swiper-item-share {
      .btn-common {
        width: 240px;
        height: 44px;
        border-radius: 44px;
      }

      .share-goods {
        font-size: 14px;
      }
    }
    .share-wrapper {
      .share-img {
        height: 80vh;
      }
    }
  }

  // .text-1 {
  //   animation: slide-in-bottom 1s ease 0s 1 normal backwards;
  //   animation-delay: 0s;
  // }
  // .text-2 {
  //   animation: slide-in-bottom 1s ease 0s 1 normal backwards;
  //   animation-delay: 0.5s;
  // }
  // .text-3 {
  //   animation: slide-in-bottom 1s ease 0s 1 normal backwards;
  //   animation-delay: 1s;
}
.service-popup {
  .authrize-commit {
    color: rgba($color: #000000, $alpha: 0.7);
    line-height: 1.5;
  }
  .btn-common {
    margin-top: 24px;
  }
}
#poster {
  width: 375px;
  top: -9099px;
  position: fixed;
  font-size: 14px;
  height: 625px;
  overflow: hidden;
  .user-detail {
    position: absolute;
    top: 39px;
    left: 0;
    right: 0;
    text-align: center;
    color: #fff;
    .user-avtarUrl {
      width: 56px;
      height: 56px;
      display: inline-block;
      border-radius: 50%;
      overflow: hidden;
    }
    .user-list {
      margin-top: 20px;
      :first-child {
        margin-bottom: 8px;
      }
      :last-child {
        font-size: 20px;
      }
    }
  }
  .share-detail {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 12px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    .share-content {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      .commit {
        font-size: 12px;
        margin-top: 7px;
        color: rgba($color: #000000, $alpha: 0.5);
      }
    }
    .qr {
      width: 56px;
    }
  }
}
.share-wrapper {
  margin: 5vh 0.48rem;
  text-align: center;
  .share-img {
    border-radius: 0.16rem;
  }
  .share-commit {
    margin-top: 0.48rem;
    color: #fff;
  }
}
.btn-common {
  width: 4.8rem;
  height: 0.88rem;
  border-radius: 0.44rem;
}
.d7994c {
  color: #d7994c;
}
.fbe674 {
  color: #fbe674;
}
</style>
